import {
  ContextField,
  ContextSelectedOptions,
  ContextSelector
} from "@appretio/context-selector";
import { Button, DataTable, Sheet } from "@appretio/ui-kit";
import { useState } from "react";
import {
  contextActionsContainer,
  contextContainer,
  contextSelectorsContainer
} from "./ForecastPage.css";

const FORECAST_CONTEXT_FIELDS: ContextField[] = [
  "brand",
  "sub_brand",
  "product_line",
  "collection_type",
  "product_category",
  "collection_name",
  "chain",
  "sales_location",
  "channel",
  "country"
];

export function ForecastPage() {
  const [selectedContextOptions, setSelectedContextOptions] =
    useState<ContextSelectedOptions>({});

  function clearSelectedOption() {
    setSelectedContextOptions({});
  }

  return (
    <>
      <Sheet>
        <div className={contextContainer}>
          <div className={contextSelectorsContainer}>
            <ContextSelector
              fields={FORECAST_CONTEXT_FIELDS}
              selected={selectedContextOptions}
              setSelected={setSelectedContextOptions}
            />
          </div>
          <div className={contextActionsContainer}>
            <Button variant="secondary" onClick={clearSelectedOption}>
              Clear
            </Button>
            <Button>Apply</Button>
          </div>
        </div>
      </Sheet>

      <Sheet>
        <DataTable
          rowData={[]}
          columnDefs={[]}
          rowHeight={75}
          gridOptions={{}}
        />
      </Sheet>
    </>
  );
}
